import type { JSX, ReactNode } from 'react'

interface EmptyStateProps {
  title: string
  description?: string
  icon?: string  // PrimeReact icon class, default 'pi pi-inbox'
  action?: ReactNode  // typically a Button
}

export function EmptyState({ title, description, icon = 'pi pi-inbox', action }: EmptyStateProps): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center" role="status">
      <i className={`${icon} text-5xl text-gray-300 mb-3`} aria-hidden />
      <h3 className="text-lg font-medium text-gray-700">{title}</h3>
      {description && <p className="text-sm text-gray-500 mt-1 max-w-md">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  )
}

export default EmptyState
